<template>
    <div class="page-app">
        <div class="inner">
            <div class="logo">
                <img src="../../assets/images/download/logo.png" alt="" @click="$router.push('/')">
            </div>
            <div class="download">
                <div class="col-1">
                    <div class="android">
                        <a v-if="download_android" target="_blank" :href="download_android" >
                            <img src="../../assets/images/download/android.png" alt="" class="scale">
                        </a>
                    </div>
                    <div class="ios">
                        <a v-if="download_ios" target="_blank" :href="download_ios" >
                            <img src="../../assets/images/download/ios.png" alt="" class="scale">
                        </a>
                    </div>
                </div>
                <div class="col-2">
                    <img :src="qrcode_img" alt="" class="scale">
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
    import { getConfig } from '@/api/config.js';
    export default {
        data() {
            return {
                download_ios : "",
                download_android : "",
                qrcode_img: ""
            }
        },
        created() {
            getConfig().then((response)=>{
                if (response.data.code == 200) {
                    this.download_android = response.data.data.android;
                    this.download_ios = response.data.data.ios;
                    this.qrcode_img = response.data.data.down_ewm;
                }
            });
        }
    }
</script>

<style lang="scss">
    .page-app {
        background-image:url('../../assets/images/download/bg.jpg');
		background-repeat:no-repeat;
		background-size:cover;
		width:100%;
		height:100%;
        text-align: center;
        position: fixed;
        left: 0;
        right: 0;
        min-width: 375px;
        min-height: 700px;
        img {
            cursor: pointer;
        }
        .logo {
            margin-top: 50px;
            
        }
        .android {
            margin-top: 20px;
        }
        .scale:hover{
            transform:scale(1.2);//放大缩小
        }
        .download {
            display: flex;
            justify-content: center;
            .col-1 {
                width: 300px;
            }
            .col-2 {
                width: 200px;
                height: 200px;
                text-align: right;
                img {
                    width: 180px;
                    margin-top: 20px;
                }
            }
        }

        @media screen and (max-width:750px){
            .download
            {
                flex-flow: column;
                align-items: center;
                .col-2 {
                    text-align: center;
                }
            }
        }
    }    
</style>



// WEBPACK FOOTER //
// src/components/download/app.vue